module.exports = __webpack_public_path__ + "static/media/twitter-icon.753a8c5e.svg";